import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import emptylist from "../../Assets/Svg/illustration-no-policy.svg";

const IntroductionComponent = ({ imageSrc, heading, subheading, onCreate, permissions }) => (
    <div className="content-outer-wrapper">
      <Grid container className="height100">
        <Grid item xs={12} md={12} sm={12}>
          <div className="display-table height100 width100">
            <div className="display-table-cell vertical-middle">
              <div className="text-center">
                <img src={imageSrc || emptylist} width="25%"></img>
              </div>
              <div className="page-header-name text-center">{heading}</div>
              <div className="page-subheader-name text-center">{subheading}</div>
              <div className="text-center">
                {onCreate && permissions.editable && (
                  <Button className="btn btn-primary-md-blue" color="primary" variant="contained" style={{ width: 140 }} onClick={onCreate}>
                    Create
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(
    null,
    mapDispatchToProps,
  )(withStyles()(withSnackbar(IntroductionComponent))),
);
